import _ from 'lodash'
// Hooks
import {useRouteParams} from '../hooks/use-route-params'
// Components
import BoundLink from './bound-link'
// Utils
import {calculateHasOnlyOneGroup} from '../utils/ballot-calculators'
import slugify from '../utils/slugify'
// Types
import type {Ballot, SeededDestination} from '../types/ballot'
// Styles
import styles from './navbar-question-list.module.scss'

interface NavbarQuestionListProps {
  ballot: Ballot | null
  allQuestions: SeededDestination[]
  onPaginate?: ((page: number) => void) | null
}

const NavbarQuestionList = ({
  ballot,
  allQuestions,
  onPaginate,
}: NavbarQuestionListProps) => {
  // Router is not used directly; kept for consistency if needed elsewhere
  // const router = useRouter()
  const {isReady, groupSlug, questionSlug} = useRouteParams()
  // 'categories' is not a group slug by default, and this can be accessed when there is no group_slug
  const singleGroupName = _.first(ballot?.parent_categories)?.parent_category_name
  const singleGroupSlug = slugify(_.trim(singleGroupName))
  const currentGroupSlug = calculateHasOnlyOneGroup(ballot) ? singleGroupSlug : (isReady ? groupSlug : null)
  const currentQuestionSlug = isReady ? questionSlug : null

  const getCurrentQuestionIndex = () => _.findIndex(allQuestions, question => question.type === 'question' && slugify(question.name) === currentQuestionSlug)
  const getDestinationIndex = (destination: SeededDestination) =>
    _.findIndex(allQuestions, question => question._id === destination._id)

  return !_.isEmpty(allQuestions)
    ? (
      <div className={styles['navbar-question-list']}>
        <h2>Categories</h2>
        {_.map(allQuestions, thisQuestion => {
          if (thisQuestion.type === 'question') {
            const newPage = getDestinationIndex(thisQuestion) - getCurrentQuestionIndex()

            if (onPaginate) {
              return (
                <button
                  key={thisQuestion?._id}
                  onClick={() => onPaginate(newPage)}
                  className={styles['__link']}
                  data-active={slugify(thisQuestion?.name) === currentQuestionSlug}
                >
                  {thisQuestion?.name}
                </button>
              )
            }
            return (
              <BoundLink
                key={thisQuestion?._id}
                href={`/${currentGroupSlug}/${slugify(thisQuestion?.name)}`}
                className={styles['__link']}
                data-active={slugify(thisQuestion?.name) === currentQuestionSlug}
              >
                {thisQuestion?.name}
              </BoundLink>
            )
          }
        })}
      </div>
    )
    : null
}

export default NavbarQuestionList
